module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADJSURBVEhL7ZFLCgIxEESDeACv4yH8nMIjqChez7UbwQuoK3EnKKJTNRgJIaXJNLgYfPAg6XRXholrHWN4gM9I1kbQzBHG4d49NOPDYlS9mDBIrU2o0HBtQoWGaxMq6H/Bm59dYFVygqmBEi9QsoZsmtW7MuaQs5t6J1hANm1hl4VM2LuDnOVFkh48QzYuWchkBTnDWWZ8ZAgfL6ewAxU84+9k7x0OYBYTeIP8Kr6Lwr/ZFXKmiD7kMFX4c/Y2wgd8szGpsJStxbkKAbiKCjpescMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-toilet-bowl/dark/24.png
// module id = 2500
// module chunks = 2